import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Testimonios" title="Lo que dicen quienes ya utilizan el material" width="narrow" data-id="element-177" data-mp="3fze2zvj28zum">
      <ul className="mx-auto max-w-4xl divide-y divide-blue-200/70" data-id="element-178" data-mp="3b143x9u7tf3q">
        {testimonials.map(item => <li key={item.role} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-179" data-mp="36z94kavuhbsl">
            <div className="flex items-start gap-3" data-id="element-180" data-mp="2x0temb8k08ko">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white" data-id="element-181" data-mp="2x1l02t8fspx8">
                {item.initials}
              </span>
              <span data-id="element-182" data-mp="v8difd5cpw86">
                <span className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-183" data-mp="v8ncpcxfipjo">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-184" data-mp="h5os1hpjsial" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-extrabold tracking-tight text-slate-900" data-id="element-185" data-mp="m2yf4qpgshv9">
                  {item.author}
                </span>
                <span className="block text-sm text-slate-600" data-id="element-186" data-mp="c623ic49rfmh">{item.role}</span>
                <span className="inline-flex items-center gap-1 text-sm text-slate-500" data-id="element-187" data-mp="zwppu2exm7sk">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-188" data-mp="14vj1dpanroq3" />
                  {item.city}
                </span>
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-slate-900 md:text-xl" data-id="element-189" data-mp="q6ctze1o2s74">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}